/*
===================================================================================================
  This service will handle station api request for LASER and FAX
===================================================================================================
*/

import { PrinterType } from '../../enums/enum';
import createNewApiClient from '../apiClient';
import { getResponseArray } from '../../utils/responseArray';

const getLaserStationsRestPath = '/jetstream/api/1/getlaserstations';

const getStationName = (station: unknown): string | undefined => {
  if (typeof station === 'string') {
    return station.trim();
  }

  if (!station || typeof station !== 'object') {
    return undefined;
  }

  const stationRecord = station as Record<string, unknown>;
  const stationValue =
    stationRecord.stationCode ??
    stationRecord.station ??
    stationRecord.code ??
    stationRecord.value ??
    stationRecord.StationCode ??
    stationRecord.Station ??
    stationRecord.Code ??
    stationRecord.Value;

  return typeof stationValue === 'string' ? stationValue.trim() : undefined;
};

const normalizeStationResponse = (responseData: unknown): string[] => {
  const stationNodes = getResponseArray(responseData, 'stations');

  return stationNodes
    .map((station) => getStationName(station))
    .filter((station): station is string => Boolean(station));
};

const stationApiRequestService = async (
  url: string,
  printerType: string,
  accessToken?: string,
): Promise<string[]> => {
  if (!url) {
    throw new Error('URL is not provided');
  }

  if (printerType !== PrinterType.LASER) {
    throw new Error('Invalid printer type');
  }

  if (url !== getLaserStationsRestPath) {
    throw new Error('Invalid endpoint for station API');
  }

  if (!accessToken?.trim()) {
    throw new Error('Access token is not provided');
  }

  const response = await createNewApiClient(accessToken).get(
    getLaserStationsRestPath,
  );
  const responseData = response?.data as unknown;
  return normalizeStationResponse(responseData);
};

export default stationApiRequestService;
